import {
  RAKUTEN_LIST,
  RAKUTEN_LIST_FAILURE,
  RAKUTEN_LIST_SUCCESS,
} from "../../constants/constants.js";

const initialState = {
  message: "",
  error: null,
  getRakutenData: [],
};

const RakutenReducer = (state = initialState, action) => {
  console.log(14, "action?.payload",action?.payload)
  
  switch (action.type) {
    case RAKUTEN_LIST:
      return {
        ...state,
      };
    case RAKUTEN_LIST_SUCCESS:
      return {
        ...state,
        userData: action?.payload?.data,
        getRakutenData: action?.payload,
        message: action?.payload?.message,
        error: null,
      };
    case RAKUTEN_LIST_FAILURE:
      return {
        ...state,
        message: action?.payload,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default RakutenReducer;
